import css from 'styled-jsx/css';

const styles = css.global`.pagination-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.pagination-container .bullet {
  background-color: #d0d0cf;
  height: 12px;
  width: 12px;
  margin-right: 8px;
  outline: none;
}

.pagination-container .bullet.remove-margin {
  margin: 0;
}

.pagination-container .bullet.clickable {
  cursor: pointer;
}

.pagination-container .bullet.active,
.pagination-container .bullet[selected] {
  background-color: #cc0000;
  outline: none;
}
`;

export default styles;